import React, { createContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'ar';
  });
  
  const [direction, setDirection] = useState(() => {
    return localStorage.getItem('direction') || 'rtl';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    localStorage.setItem('direction', direction);
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
  }, [language, direction]);

  const toggleLanguage = (newLang) => {
    setLanguage(newLang);
    setDirection(newLang === 'ar' ? 'rtl' : 'ltr');
  };

  const toggleDirection = (newDir) => {
    setDirection(newDir);
  };

  return (
    <LanguageContext.Provider value={{ language, direction, toggleLanguage, toggleDirection }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;

